export class HabitTypeModel {
   public HabitTypeId:number;
   public HabitTypeName:string;
   public HabitTypeAutoComplete:any;
   public HabitTypelist:HabitTypeModel[];
   public Checked:boolean;

}
